/* eslint react/no-unknown-property:0 */
import PropTypes from 'prop-types';
import React from 'react';

import colors from 'styleguide/colors';
import { icon } from 'styleguide/utils/hoc';

const CanduIcon = ({ color, width, height, mono }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 280 280"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M160.874 115.695V171.695C160.874 176.345 164.644 180.115 169.294 180.115H190.954C195.904 180.115 199.834 175.855 199.344 170.925C196.504 142.785 180.844 120.395 160.874 115.695Z"
      fill={mono ? color : colors('orange')}
    />
    <path
      d="M89.4743 180.115H133.804C138.454 180.115 142.224 176.345 142.224 171.695V78.475C109.404 86.205 83.9343 124.205 81.0643 171.235C80.7743 176.055 84.6543 180.115 89.4743 180.115Z"
      fill={mono ? color : colors('red')}
    />
    <path
      d="M253.984 165.045C241.434 159.175 226.364 165.255 220.434 177.765C218.284 182.305 215.794 186.595 212.994 190.625C209.284 195.965 203.164 199.115 196.664 199.115H82.3643C75.9043 199.115 69.8043 196.015 66.1043 190.725C57.8443 178.935 52.5343 165.235 50.7143 150.545C47.7643 126.825 54.2343 103.375 68.9243 84.5151C83.6143 65.6551 104.764 53.6551 128.494 50.7051C147.904 48.2951 167.104 52.1451 184.004 61.855C200.194 71.1451 213.304 85.5251 220.984 102.395C226.714 114.975 241.674 121.275 254.294 115.635C266.884 110.005 272.544 95.225 266.914 82.625C254.994 55.905 234.384 33.125 208.894 18.495C182.514 3.34505 152.574 -2.66494 122.324 1.08506C85.3443 5.67506 52.3743 24.395 29.4743 53.785C6.57429 83.175 -3.50571 119.725 1.08429 156.705C5.67429 193.685 24.3943 226.655 53.7843 249.555C78.5343 268.835 108.354 279.025 139.224 279.025C145.014 279.025 150.854 278.665 156.704 277.935C204.744 271.965 245.634 242.165 266.064 198.225C271.874 185.725 266.464 170.885 253.984 165.045Z"
      fill={mono ? color : colors('primary')}
    />
  </svg>
);

CanduIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mono: PropTypes.bool,
};

export default icon(CanduIcon);
